// extracted by mini-css-extract-plugin
module.exports = {"mobileWidth":"850px","wrapper":"iconCTA-module__wrapper___1DxI0"};